export default __webpack_public_path__ + "static/media/maintainance.a69fbc52.png";